import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GuideStyles from "assets/js/guide";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Input,
  InputLabel,
  InputAdornment,
  IconButton,
  MenuItem,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Select,
  TextField,
  FormHelperText,
  OutlinedInput,
  Button,
  Box,
  Checkbox,
  Grid,
  RadioGroup,
  Radio,
} from "@mui/material";
import { useForm } from "react-hook-form";

import "codemirror/lib/codemirror.css";
import "codemirror/theme/dracula.css";
import "codemirror/theme/material.css";

import "codemirror/theme/mdn-like.css";
import "codemirror/theme/the-matrix.css";
import "codemirror/theme/night.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/css/css";

import "codemirror/addon/edit/closebrackets";
import "codemirror/addon/edit/closetag";
import { Controlled as ControlledEditor } from "react-codemirror2-react-17";

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

const GuideForm = () => {
  const [age, setAge] = useState("");
  const [personName, setPersonName] = useState([]);
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const [file, setFile] = useState(null);

  const {
    register,
    getValues,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      textarea: "",
      cnt: "",
    },
  });

  const handleChange = event => {
    setAge(event.target.value);
  };
  const handleChangeNames = event => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangePw = prop => event => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  watch("cnt", false);
  watch("textarea", false);

  /* Accordion */
  const [codemirror, setCodemirror] = useState();
  const handleCodemirror = panel => (event, newcodemirror) => {
    setCodemirror(newcodemirror ? panel : false);
  };

  return (
    <>
      <GuideStyles />
      <main id="main" className="container">
        <Box className="box-type-2">
          <div class="h-group">
            <h2 className="guide-h2">Form</h2>
          </div>

          <h3 className="guide-h3">Input</h3>
          <div className="guide-cont">
            <FormControl>
              <OutlinedInput placeholder="Type = text" />
            </FormControl>
            <br />
            <br />
            <OutlinedInput placeholder="Type = search" type="search" />
            <br />
            <br />
            <OutlinedInput placeholder="disabled" disabled />
            <br />
            <br />
            <FormControl>
              <OutlinedInput
                placeholder="error"
                error
                aria-describedby="error-text"
              />
              <FormHelperText id="error-text" className="error">
                Error
              </FormHelperText>
            </FormControl>

            <Accordion
              expanded={codemirror === "Input"}
              onChange={handleCodemirror("Input")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
  <OutlinedInput placeholder="Type = text" />
</FormControl>

<OutlinedInput placeholder="Type = search" type="search" />

<OutlinedInput placeholder="disabled" disabled />

<FormControl>
  <OutlinedInput
    placeholder="error"
    error
    aria-describedby="error-text"
  />
  <FormHelperText id="error-text" className="error">
    Error
  </FormHelperText>
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />
            <Grid container spacing={1} className="form-group-wrap">
              <Grid item xs={8} md={6}>
                <FormControl>
                  <InputLabel>생년월일</InputLabel>
                  <OutlinedInput type="tel" value="940918" disabled />
                </FormControl>
              </Grid>
              <Grid item xs={4} md={6}>
                <FormControl>
                  <InputLabel>성별</InputLabel>
                  <OutlinedInput type="text" value="여성" disabled />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <InputLabel required>이메일</InputLabel>
                <Grid container spacing={1} className="inner-grid">
                  <Grid item xs={12}>
                    <Grid container spacing={1} className="item-grid">
                      <Grid item xs>
                        <OutlinedInput type="text" />
                      </Grid>
                      <Grid item xs={1}>
                        <span className="color-disabled">@</span>
                      </Grid>
                      <Grid item xs>
                        <Select value={1}>
                          <MenuItem value={0}>직접입력</MenuItem>
                          <MenuItem value={1}>naver.com</MenuItem>
                          <MenuItem value={2}>Twenty</MenuItem>
                          <MenuItem value={3}>Thirty</MenuItem>
                        </Select>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Accordion
              expanded={codemirror === "input2"}
              onChange={handleCodemirror("input2")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Grid container spacing={1} className="form-group-wrap">
<Grid item xs={8} md={6}>
  <FormControl>
    <InputLabel>생년월일</InputLabel>
    <OutlinedInput type="tel" value="940918" disabled />
  </FormControl>
</Grid>
<Grid item xs={4} md={6}>
  <FormControl>
    <InputLabel>성별</InputLabel>
    <OutlinedInput type="text" value="여성" disabled />
  </FormControl>
</Grid>

<Grid item xs={12} md={6}>
  <InputLabel required>이메일</InputLabel>
  <Grid container spacing={1} className="inner-grid">
    <Grid item xs={12}>
      <Grid container spacing={1} className="item-grid">
        <Grid item xs>
          <OutlinedInput type="text" />
        </Grid>
        <Grid item xs={1}>
          <span className="color-disabled">@</span>
        </Grid>
        <Grid item xs>
          <Select value={1}>
            <MenuItem value={0}>직접입력</MenuItem>
            <MenuItem value={1}>naver.com</MenuItem>
            <MenuItem value={2}>Twenty</MenuItem>
            <MenuItem value={3}>Thirty</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
</Grid>
</Grid>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Input + Button</h3>
          <div className="guide-cont">
            <FormControl variant="outlined">
              <OutlinedInput
                placeholder="궁금하신 내용을 검색해주세요"
                type="search"
                className="search-box"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      type="submit"
                      aria-label="search"
                      className="btn-search"
                      edge="end"
                    >
                      <span className="hidden">search</span>
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Accordion
              expanded={codemirror === "InputButtonSearch"}
              onChange={handleCodemirror("InputButtonSearch")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl variant="outlined">
  <OutlinedInput
    placeholder="궁금하신 내용을 검색해주세요"
    type="search"
    className="search-box"
    endAdornment={
      <InputAdornment position="end">
        <IconButton
          type="submit"
          aria-label="search"
          className="btn-search"
          edge="end"
        >
          <span className="hidden">search</span>
        </IconButton>
      </InputAdornment>
    }
  />
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />

            <FormControl variant="outlined">
              <InputLabel>Password</InputLabel>
              <OutlinedInput
                type={values.showPassword ? "tel" : "password"}
                value={values.password}
                onChange={handleChangePw("password")}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="view"
                      type="button"
                      className={
                        values.showPassword ? "btn-view-off" : "btn-view"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    />
                  </InputAdornment>
                }
              />
            </FormControl>

            <Accordion
              expanded={codemirror === "InputButtonPw"}
              onChange={handleCodemirror("InputButtonPw")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl variant="outlined">
  <InputLabel>Password</InputLabel>
  <OutlinedInput
    type={values.showPassword ? "tel" : "password"}
    value={values.password}
    onChange={handleChangePw("password")}
    endAdornment={
      <InputAdornment position="end">
        <IconButton
          aria-label="view"
          type="button"
          className={
            values.showPassword ? "btn-view-off" : "btn-view"
          }
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
          edge="end"
        />
      </InputAdornment>
    }
  />
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />

            <FormControl variant="outlined">
              <OutlinedInput
                type="text"
                inputProps={{
                  maxLength: 10,
                }}
                {...register("cnt")}
                endAdornment={
                  <InputAdornment position="end">
                    <span className="count">{getValues("cnt").length}/10</span>
                    <Button aria-label="registration" type="button" edge="end">
                      등록
                    </Button>
                  </InputAdornment>
                }
              />
            </FormControl>

            <Accordion
              expanded={codemirror === "InputButtonRegist"}
              onChange={handleCodemirror("InputButtonRegist")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl variant="outlined">
  <OutlinedInput
    type="text"
    inputProps={{
      maxLength: 10,
    }}
    {...register("cnt")}
    endAdornment={
      <InputAdornment position="end">
        <span className="count">{getValues("cnt").length}/10</span>
        <Button aria-label="registration" type="button" edge="end">
          등록
        </Button>
      </InputAdornment>
    }
  />
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />

            <Grid container spacing={1} className="form-group-wrap">
              <Grid item xs={12} md={6}>
                <InputLabel required>주소</InputLabel>
                <Grid container spacing={1} className="inner-grid">
                  <Grid item xs={12}>
                    <Grid container spacing={1} className="item-grid">
                      <Grid item xs={7}>
                        <OutlinedInput
                          type="text"
                          readOnly
                          id="postcode"
                          aria-label="postcode"
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <Button variant="contained" color="common">
                          우편번호 검색
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Accordion
              expanded={codemirror === "InputButtonPost"}
              onChange={handleCodemirror("InputButtonPost")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<Grid container spacing={1} className="form-group-wrap">
  <Grid item xs={12} md={6}>
    <InputLabel required>주소</InputLabel>
    <Grid container spacing={1} className="inner-grid">
      <Grid item xs={12}>
        <Grid container spacing={1} className="item-grid">
          <Grid item xs={7}>
            <OutlinedInput
              type="text"
              readOnly
              id="postcode"
              aria-label="postcode"
            />
          </Grid>
          <Grid item xs={5}>
            <Button variant="contained" color="common">
              우편번호 검색
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
</Grid>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />

            <label htmlFor="contained-button-file" className="form-file">
              <OutlinedInput
                accept="image/*"
                id="contained-button-file"
                multiple
                type="file"
                onChange={e => {
                  setFile(e.target.files[0].name);
                }}
                startAdornment={
                  <InputAdornment position="start">
                    <span className="nm ellipsis">{file}</span>
                  </InputAdornment>
                }
              />

              <Button variant="contained" component="span">
                Upload
              </Button>
            </label>
            <br />
            <label
              htmlFor="contained-button-file-disabled"
              className="form-file"
            >
              <OutlinedInput
                accept="image/*"
                id="contained-button-file-disabled"
                multiple
                type="file"
                onChange={e => {
                  setFile(e.target.files[0].name);
                }}
                disabled
                startAdornment={
                  <InputAdornment position="start">
                    <span className="nm ellipsis">{file}</span>
                  </InputAdornment>
                }
              />

              <Button variant="contained" component="span">
                Upload
              </Button>
            </label>

            <Accordion
              expanded={codemirror === "InputButtonFile"}
              onChange={handleCodemirror("InputButtonFile")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<label htmlFor="contained-button-file" className="form-file">
  <OutlinedInput
    accept="image/*"
    id="contained-button-file"
    multiple
    type="file"
    onChange={e => {
      setFile(e.target.files[0].name);
    }}
    startAdornment={
      <InputAdornment position="start">
        <span className="nm ellipsis">{file}</span>
      </InputAdornment>
    }
  />

  <Button variant="contained" component="span">
    Upload
  </Button>
</label>

<label
  htmlFor="contained-button-file-disabled"
  className="form-file"
>
  <OutlinedInput
    accept="image/*"
    id="contained-button-file-disabled"
    multiple
    type="file"
    onChange={e => {
      setFile(e.target.files[0].name);
    }}
    disabled
    startAdornment={
      <InputAdornment position="start">
        <span className="nm ellipsis">{file}</span>
      </InputAdornment>
    }
  />

  <Button variant="contained" component="span">
    Upload
  </Button>
</label>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Input - Label</h3>
          <div className="guide-cont">
            <FormControl>
              <InputLabel required shrink>
                Label
              </InputLabel>
              <OutlinedInput id="label" placeholder="placeholder" />
              {/* <FormHelperText id="error-text" className="error">
                Error
              </FormHelperText> */}
            </FormControl>

            <Accordion
              expanded={codemirror === "InputLabel"}
              onChange={handleCodemirror("InputLabel")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
  <InputLabel required shrink>
    Label
  </InputLabel>
  <OutlinedInput id="label" placeholder="placeholder" />
  {/* <FormHelperText id="error-text" className="error">
    Error
  </FormHelperText> */}
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Select - No Label</h3>
          <div className="guide-cont">
            <FormControl>
              <Select
                displayEmpty
                value={personName}
                onChange={handleChangeNames}
              >
                <MenuItem disabled value="">
                  <em className="placeholder">Placeholder</em>
                </MenuItem>
                {names.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            <br />
            <FormControl>
              <Select
                labelId="select1"
                id="select1"
                value={age}
                label="Age"
                onChange={handleChange}
              >
                <MenuItem value={10}>Ten</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl>
            <br />
            <br />
            <FormControl>
              <Select displayEmpty value={10} disabled>
                <MenuItem value={10}>선택 불가</MenuItem>
                <MenuItem value={20}>Twenty</MenuItem>
                <MenuItem value={30}>Thirty</MenuItem>
              </Select>
            </FormControl>

            <Accordion
              expanded={codemirror === "select"}
              onChange={handleCodemirror("select")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
  <Select
    displayEmpty
    value={personName}
    onChange={handleChangeNames}
  >
    <MenuItem disabled value="">
      <em className="placeholder">Placeholder</em>
    </MenuItem>
    {names.map(name => (
      <MenuItem key={name} value={name}>
        {name}
      </MenuItem>
    ))}
  </Select>
</FormControl>

<FormControl>
  <Select
    labelId="select1"
    id="select1"
    value={age}
    label="Age"
    onChange={handleChange}
  >
    <MenuItem value={10}>Ten</MenuItem>
    <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem>
  </Select>
</FormControl>

<FormControl>
  <Select displayEmpty value={10} disabled>
    <MenuItem value={10}>선택 불가</MenuItem>
    <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem>
  </Select>
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Select - Label</h3>
          <div className="guide-cont">
            <FormControl>
              <InputLabel>Age</InputLabel>
              <Select
                value={age}
                onChange={handleChange}
                label="Age"
                displayEmpty
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                <MenuItem value={10}>Twenty</MenuItem>
                <MenuItem value={21}>Twenty one</MenuItem>
                <MenuItem value={22}>Twenty one and a half</MenuItem>
              </Select>
            </FormControl>

            <Accordion
              expanded={codemirror === "selectLabel"}
              onChange={handleCodemirror("selectLabel")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
  <InputLabel>Age</InputLabel>
  <Select
    value={age}
    onChange={handleChange}
    label="Age"
    displayEmpty
  >
    <MenuItem value="">
      <em>None</em>
    </MenuItem>
    <MenuItem value={10}>Twenty</MenuItem>
    <MenuItem value={21}>Twenty one</MenuItem>
    <MenuItem value={22}>Twenty one and a half</MenuItem>
  </Select>
</FormControl>
              `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Checkbox</h3>
          <div className="guide-cont">
            <div>
              <form>
                <FormGroup row>
                  <Checkbox
                    color="primary"
                    icon={<span className="checkbox-icon" />}
                    checkedIcon={<span className="checkbox-icon-checked" />}
                  />
                  <Checkbox
                    color="primary"
                    icon={<span className="checkbox-icon" />}
                    checkedIcon={<span className="checkbox-icon-checked" />}
                  />
                </FormGroup>
                <br />
                <FormGroup>
                  <FormControlLabel
                    value="Apple"
                    control={
                      <Checkbox
                        defaultChecked
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Apple"
                  />
                  <FormControlLabel
                    value="Orange"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Orange"
                  />
                  <FormControlLabel
                    value="Melon"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Melon"
                  />
                  <FormControlLabel
                    value="Grape"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Grape"
                  />
                </FormGroup>
              </form>
              <FormControlLabel
                value="Grape"
                className="align-start"
                control={
                  <Checkbox
                    color="primary"
                    icon={<span className="checkbox-icon" />}
                    checkedIcon={<span className="checkbox-icon-checked" />}
                  />
                }
                label="본인은 회원탈퇴 유의사항 및 이용약관, 개인정보
                  처리 방침 내용을 확인하였으며 동의합니다."
              />

              <Accordion
                expanded={codemirror === "checkbox"}
                onChange={handleCodemirror("checkbox")}
                className="accordion-codemirror"
              >
                <AccordionSummary>
                  <p>코드보기</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ControlledEditor
                    value={`<form>
<FormGroup row>
  <Checkbox
    color="primary"
    icon={<span className="checkbox-icon" />}
    checkedIcon={<span className="checkbox-icon-checked" />}
  />
  <Checkbox
    color="primary"
    icon={<span className="checkbox-icon" />}
    checkedIcon={<span className="checkbox-icon-checked" />}
  />
</FormGroup>

<FormGroup>
  <FormControlLabel
    value="Apple"
    control={
      <Checkbox
        defaultChecked
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Apple"
  />
  <FormControlLabel
    value="Orange"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Orange"
  />
  <FormControlLabel
    value="Melon"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Melon"
  />
  <FormControlLabel
    value="Grape"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Grape"
  />
</FormGroup>
</form>

<FormControlLabel
value="Grape"
className="align-start"
control={
  <Checkbox
    color="primary"
    icon={<span className="checkbox-icon" />}
    checkedIcon={<span className="checkbox-icon-checked" />}
  />
}
label="본인은 회원탈퇴 유의사항 및 이용약관, 개인정보
  처리 방침 내용을 확인하였으며 동의합니다."
/>
                `}
                    className="code-mirror-wrapper"
                    options={{
                      lineWrapping: true,
                      lint: true,
                      mode: "xml",
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
            <br />
            <br />

            <div>
              <FormControl component="fieldset">
                <FormLabel component="legend" focused={false}>
                  Row
                </FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    value="Apple"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Apple"
                  />
                  <FormControlLabel
                    value="Orange"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Orange"
                  />
                  <FormControlLabel
                    value="Melon"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Melon"
                  />
                </FormGroup>
              </FormControl>

              <Accordion
                expanded={codemirror === "checkboxRow"}
                onChange={handleCodemirror("checkboxRow")}
                className="accordion-codemirror"
              >
                <AccordionSummary>
                  <p>코드보기</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ControlledEditor
                    value={`<FormControl component="fieldset">
<FormLabel component="legend" focused={false}>
  Row
</FormLabel>
<FormGroup row>
  <FormControlLabel
    value="Apple"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Apple"
  />
  <FormControlLabel
    value="Orange"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Orange"
  />
  <FormControlLabel
    value="Melon"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Melon"
  />
</FormGroup>
</FormControl>
                `}
                    className="code-mirror-wrapper"
                    options={{
                      lineWrapping: true,
                      lint: true,
                      mode: "xml",
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
            <br />
            <br />

            <div>
              <FormControl component="fieldset">
                <FormLabel component="legend" focused={false}>
                  Disabled
                </FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    disabled
                    checked
                    value="Apple"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Apple"
                  />
                  <FormControlLabel
                    disabled
                    value="Orange"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Orange"
                  />
                  <FormControlLabel
                    disabled
                    value="Melon"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                      />
                    }
                    label="Melon"
                  />
                </FormGroup>
              </FormControl>

              <Accordion
                expanded={codemirror === "checkboxDisabled"}
                onChange={handleCodemirror("checkboxDisabled")}
                className="accordion-codemirror"
              >
                <AccordionSummary>
                  <p>코드보기</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ControlledEditor
                    value={`<FormControl component="fieldset">
<FormLabel component="legend" focused={false}>
  Disabled
</FormLabel>
<FormGroup row>
  <FormControlLabel
    disabled
    checked
    value="Apple"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Apple"
  />
  <FormControlLabel
    disabled
    value="Orange"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Orange"
  />
  <FormControlLabel
    disabled
    value="Melon"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
      />
    }
    label="Melon"
  />
</FormGroup>
</FormControl>
                `}
                    className="code-mirror-wrapper"
                    options={{
                      lineWrapping: true,
                      lint: true,
                      mode: "xml",
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </div>

            <br />
            <br />

            <div>
              <FormControl component="fieldset">
                <FormLabel component="legend" focused={false}>
                  Checkbox - No border
                </FormLabel>
                <FormGroup row>
                  <FormControlLabel
                    value="Melon"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                        className="noborder"
                      />
                    }
                    label={<span className="font-14">Melon</span>}
                  />
                  <FormControlLabel
                    disabled
                    value="Apple"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                        className="noborder"
                      />
                    }
                    label={<span className="font-14">disabled</span>}
                  />
                  <FormControlLabel
                    checked
                    disabled
                    value="Orange"
                    control={
                      <Checkbox
                        color="primary"
                        icon={<span className="checkbox-icon" />}
                        checkedIcon={<span className="checkbox-icon-checked" />}
                        className="noborder"
                      />
                    }
                    label={<span className="font-14">disabled</span>}
                  />
                </FormGroup>
              </FormControl>

              <Accordion
                expanded={codemirror === "checkboxNoborder"}
                onChange={handleCodemirror("checkboxNoborder")}
                className="accordion-codemirror"
              >
                <AccordionSummary>
                  <p>코드보기</p>
                </AccordionSummary>
                <AccordionDetails>
                  <ControlledEditor
                    value={`<FormControl component="fieldset">
<FormLabel component="legend" focused={false}>
  Checkbox - No border
</FormLabel>
<FormGroup row>
  <FormControlLabel
    value="Melon"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
        className="noborder"
      />
    }
    label={<span className="font-14">Melon</span>}
  />
  <FormControlLabel
    disabled
    value="Apple"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
        className="noborder"
      />
    }
    label={<span className="font-14">disabled</span>}
  />
  <FormControlLabel
    checked
    disabled
    value="Orange"
    control={
      <Checkbox
        color="primary"
        icon={<span className="checkbox-icon" />}
        checkedIcon={<span className="checkbox-icon-checked" />}
        className="noborder"
      />
    }
    label={<span className="font-14">disabled</span>}
  />
</FormGroup>
</FormControl>
                `}
                    className="code-mirror-wrapper"
                    options={{
                      lineWrapping: true,
                      lint: true,
                      mode: "xml",
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </div>

          <hr className="guide-hr" />

          <h3 className="guide-h3">Radio</h3>
          <div className="guide-cont">
            <form>
              <Radio
                value="a"
                name="radio-buttons"
                color="primary"
                icon={<span className="radio-icon" />}
                checkedIcon={<span className="radio-icon-checked" />}
              />
              <Radio
                value="b"
                name="radio-buttons"
                color="primary"
                icon={<span className="radio-icon" />}
                checkedIcon={<span className="radio-icon-checked" />}
              />
              <br />
              <br />
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="female"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Male"
                />
                <FormControlLabel
                  value="other"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Other"
                />
              </RadioGroup>
            </form>

            <Accordion
              expanded={codemirror === "radio"}
              onChange={handleCodemirror("radio")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<form>
<Radio
  value="a"
  name="radio-buttons"
  color="primary"
  icon={<span className="radio-icon" />}
  checkedIcon={<span className="radio-icon-checked" />}
/>
<Radio
  value="b"
  name="radio-buttons"
  color="primary"
  icon={<span className="radio-icon" />}
  checkedIcon={<span className="radio-icon-checked" />}
/>
<br />
<br />
<RadioGroup
  aria-labelledby="demo-radio-buttons-group-label"
  defaultValue="female"
  name="radio-buttons-group"
>
  <FormControlLabel
    value="female"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Female"
  />
  <FormControlLabel
    value="male"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Male"
  />
  <FormControlLabel
    value="other"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Other"
  />
</RadioGroup>
</form>
                `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />

            <FormControl>
              <FormLabel>Row</FormLabel>
              <RadioGroup row>
                <FormControlLabel
                  value="female"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Female"
                />
                <FormControlLabel
                  value="male"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Male"
                />
                <FormControlLabel
                  value="other"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Other"
                />
              </RadioGroup>
            </FormControl>

            <Accordion
              expanded={codemirror === "radioRow"}
              onChange={handleCodemirror("radioRow")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
<FormLabel>Row</FormLabel>
<RadioGroup row>
  <FormControlLabel
    value="female"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Female"
  />
  <FormControlLabel
    value="male"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Male"
  />
  <FormControlLabel
    value="other"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Other"
  />
</RadioGroup>
</FormControl>
                `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>

            <br />
            <br />

            <FormControl>
              <FormLabel>Disabled</FormLabel>
              <RadioGroup row>
                <FormControlLabel
                  value="female"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Female"
                  disabled
                  checked
                />
                <FormControlLabel
                  value="male"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Male"
                  disabled
                />
                <FormControlLabel
                  value="other"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                    />
                  }
                  label="Other"
                  disabled
                />
              </RadioGroup>
            </FormControl>

            <Accordion
              expanded={codemirror === "radioDisabled"}
              onChange={handleCodemirror("radioDisabled")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<FormControl>
<FormLabel>Disabled</FormLabel>
<RadioGroup row>
  <FormControlLabel
    value="female"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Female"
    disabled
    checked
  />
  <FormControlLabel
    value="male"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Male"
    disabled
  />
  <FormControlLabel
    value="other"
    control={
      <Radio
        color="primary"
        icon={<span className="radio-icon" />}
        checkedIcon={<span className="radio-icon-checked" />}
      />
    }
    label="Other"
    disabled
  />
</RadioGroup>
</FormControl>
                `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>

          <hr className="guide-hr" />
          <h3 className="guide-h3">TextArea</h3>
          <div className="guide-cont">
            <TextField
              label="Multiline"
              multiline
              rows={4}
              placeholder="Placeholder"
              variant="standard"
              inputProps={{
                maxLength: 1000,
              }}
              {...register("textarea")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="bottom">
                    <span className="count">
                      {getValues("textarea").length}
                      /1000
                    </span>
                  </InputAdornment>
                ),
              }}
            />
            <br />
            <br />
            <TextField
              label="Multiline"
              multiline
              rows={4}
              placeholder="Placeholder"
              variant="standard"
              inputProps={{
                maxLength: 1000,
              }}
              disabled
              {...register("textarea")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="bottom">
                    <span className="count">
                      {getValues("textarea").length}
                      /1000
                    </span>
                  </InputAdornment>
                ),
              }}
            />

            <Accordion
              expanded={codemirror === "radioDisabled"}
              onChange={handleCodemirror("radioDisabled")}
              className="accordion-codemirror"
            >
              <AccordionSummary>
                <p>코드보기</p>
              </AccordionSummary>
              <AccordionDetails>
                <ControlledEditor
                  value={`<TextField
  label="Multiline"
  multiline
  rows={4}
  placeholder="Placeholder"
  variant="standard"
  inputProps={{
    maxLength: 1000,
  }}
  {...register("textarea")}
  InputProps={{
    startAdornment: (
      <InputAdornment position="bottom">
        <span className="count">
          {getValues("textarea").length}
          /1000
        </span>
      </InputAdornment>
    ),
  }}
/>

<TextField
  label="Multiline"
  multiline
  rows={4}
  placeholder="Placeholder"
  variant="standard"
  inputProps={{
    maxLength: 1000,
  }}
  disabled
  {...register("textarea")}
  InputProps={{
    startAdornment: (
      <InputAdornment position="bottom">
        <span className="count">
          {getValues("textarea").length}
          /1000
        </span>
      </InputAdornment>
    ),
  }}
/>
                `}
                  className="code-mirror-wrapper"
                  options={{
                    lineWrapping: true,
                    lint: true,
                    mode: "xml",
                    theme: "material",
                    lineNumbers: true,
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        </Box>
      </main>
    </>
  );
};

export default GuideForm;
